import { Button, Heading } from '@chakra-ui/react'
import { useEffect } from 'react'

import { SendContractEmailButton } from '@/containers/SendContractEmailButton'
import { SendContractContextProvider, SendContractModal } from '@/containers/SendContractModal'
import { useApp } from '@/hooks/useApp'

import { ContractAcceptationType } from 'BrokerTsLib/src/enums'
import { Container } from '../../../components/Container'
import {
  FormSection,
  FormSectionBody,
  FormSectionDescription,
  FormSectionHeader,
  FormSectionTitle,
} from '../../../components/FormSection'
import { Loading } from '../../../components/Loading'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { ContractEmailHistory } from '../../../containers/carkulka/ContractEmailHistory'
import { InsuranceDownloads } from '../../../containers/carkulka/InsuranceDownloads'
import { ContractRecap } from '../../../containers/chaloupka/ContractRecap'
import { Recap } from '../../../containers/chaloupka/Recap'
import { FormButtons } from '../../../containers/FormButtons'
import { InsuranceSummary } from '../../../containers/InsuranceSummary'
import { MeetingRecordOverview } from '../../../containers/MeetingRecordOverview'
import { StepsContent } from '../../../context/StepsContext'
import { baseUrl } from '../../../hooks'
import { Duplicate } from '../../../icons'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

const insuranceParamsApiUrl = import.meta.env.VITE_INSURANCEPARAMS_PROPERTY_API
const insuranceParamsUrl = `${baseUrl}/${insuranceParamsApiUrl}`

export const CompletedPage = () => {
  const { product, setProduct } = useApp()
  const { insuranceParams, insuranceParamsId, isLoadingData } =
    useInsuranceParamsContext()

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  const cloneUrl = `${baseUrl}/chaloupka/wizard/1`

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!insuranceParamsId || insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType) && !isLoadingData &&
          <>
            <StepsContent step={5}>
              <Heading
                sx={{
                  fontSize: '5xl',
                  fontWeight: 'bold',
                  letterSpacing: 'tighter',
                  textAlign: 'center',
                }}
                as="h1"
              >
                Sjednané pojištění č.{' '}
                {insuranceParams?.generalParams.contractNumber}
              </Heading>

              <Steps icon="house" />

              <InsuranceSummary />

              <SendContractContextProvider insuranceId={insuranceParams?.generalParams.insuranceId ?? undefined}>
                <SendContractModal />
                <MainContent>
                  <Recap />

                  <FormSection>
                    <FormSectionHeader>
                      <FormSectionTitle>Dokumenty k pojištění</FormSectionTitle>

                      <FormSectionDescription>
                        <SendContractEmailButton />
                      </FormSectionDescription>
                    </FormSectionHeader>

                    <FormSectionBody>
                      {insuranceParams?.generalParams.selectedOfferId && (
                        <InsuranceDownloads paramsId={insuranceParams.generalParams.paramsId!} insurerOfferId={insuranceParams.generalParams.selectedOfferId} />
                      )}

                      {insuranceParams?.generalParams.paramsId && (
                          <ContractEmailHistory
                            paramsId={insuranceParams?.generalParams.paramsId}
                            isAutomaticallySent={(
                              insuranceParams.generalParams.contractAcceptationType === ContractAcceptationType.Payment ||
                              insuranceParams.generalParams.contractAcceptationType === ContractAcceptationType.DigitalSignature
                            )}
                          />
                        )}
                    </FormSectionBody>
                  </FormSection>

                  {/* <ExpiredContractCancellationForm onSubmit={() => { }} hideCompany hideDate /> */}

                  <ContractRecap />

                  <MeetingRecordOverview />
                </MainContent>
              </SendContractContextProvider>
            </StepsContent>

            <FormButtons
              leftButtons={
                <Button
                  variant="outline"
                  as="a"
                  href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(cloneUrl)}`}
                >
                  <Duplicate color="secondary.500" />
                  Klonovat
                </Button>
              }
            />
          </>
        }
      </Container>
    </Section>
  )
}

